module.exports = __webpack_public_path__ + "static/Gapsi2-cb9a3703a4aa3b2e6cbb7cb9de80778f.png";